import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { parseVariantColor, toColorClassName } from '@src/utils/parseVariantColor';

const ColorSwatch = ({ color, variant = 'square', title, isLogo = false }) => {
    const { colors, isDual } = parseVariantColor(color, { isLogo });
    const baseClass = variant === 'icon' ? 'color-icon' : 'color-square';
    const titleAttr = title ?? color;

    if (isDual) {
        return (
            <span className={classNames(baseClass, 'dual')} title={titleAttr}>
                <span className={classNames('color-half', toColorClassName(colors[0]))} />
                <span className={classNames('color-half', toColorClassName(colors[1]))} />
            </span>
        );
    }

    return (
        <span
            className={classNames(baseClass, toColorClassName(colors[0] || ''))}
            title={titleAttr}
        />
    );
};

ColorSwatch.propTypes = {
    color: PropTypes.string,
    variant: PropTypes.oneOf(['square', 'icon']),
    title: PropTypes.string,
    isLogo: PropTypes.bool,
};

export default ColorSwatch;
